import { type ReactNode } from "react";
import { useScrollFadeIn } from "@/hooks/useScrollFadeIn";

interface AnimatedSectionProps {
  children: ReactNode;
  threshold?: number;
  delay?: number;
}

export default function AnimatedSection({ children, threshold = 0.1, delay = 0 }: AnimatedSectionProps) {
  const { ref, visible } = useScrollFadeIn(threshold);

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}